module.exports = __webpack_public_path__ + "static/media/WelcomeImage.984d5f03.jpeg";